import { render, staticRenderFns } from "./DLayout.vue?vue&type=template&id=23c1641f&scoped=true&"
import script from "./DLayout.vue?vue&type=script&lang=js&"
export * from "./DLayout.vue?vue&type=script&lang=js&"
import style0 from "./DLayout.vue?vue&type=style&index=0&id=23c1641f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c1641f",
  null
  
)

export default component.exports